import React from 'react';
import * as Utils from "../../inc/Utils";
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useParams, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import {API_TYPE_LINE_OAID} from "../../inc/Utils";

export default function UtmSourceEdit() {
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let utmSourceId = decode.id;
    let utmId = decode.utmId;
    let utmTitle = decode.utmTitle;
    let utmSourceTitle = decode.utmSourceTitle;

    let backPath = '/utmSource/' + Utils.encodeItem({utmId: utmId, utmTitle: utmTitle});

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [inputType, setInputType] = React.useState(null);
    let [defaultCheckType, setDefaultCheckType] = React.useState(null);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [selectedDefaultChecked, setDefaultChecked] = React.useState(false);
    let [encryptChecked, setEncryptChecked] = React.useState(false);
    const navigate = useNavigate();

    let refName = React.useRef();
    let refPrefix = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                setEncryptChecked(resView.isEncrypt===1);
                refName.current.value = resView.name;
                refPrefix.current.value = resView.prefix;
                setInputType(resView.inputType);
                setDefaultChecked(resView.defaultCheckType);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/utmSource/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: utmSourceId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let name = refName.current.value;
        let prefix = refPrefix.current.value;
 
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ UTM " + utmTitle);
            refName.current.focus();
        }
        else if(encryptChecked && (!prefix || !/^[A-Z]*$/.test(prefix))) {
            toast.error("กรุณาระบุ Prefix เป็นตัวอักษรพิมพ์ใหญ่ A-Z จำนวน 1 ตัวอักษร เช่น A");
            refPrefix.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');
                            let encryptChecked = document.getElementsByName('encryptChecked');

                            const body = {
                                id: data.id,
                                utmId: utmId,
                                name: name.toString().trim(),
                                currentName: data.name.toString().trim(),
                                currentPrefix: data.prefix?.toString().trim() ?? '',
                                status: statusChecked[0].checked ? 1:0,
                                isEncrypt: encryptChecked[0].checked ? 1:0,
                                prefix: prefix.toString().trim(),
                                inputType: inputType ?? null,
                                defaultCheckType: defaultCheckType ?? null,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/utmSource/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(backPath, {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeInputType = (Id) => {
        setInputType(Id);
    };

    const onChangeDefaultCheckType = (Id) => {
       if(Id) {
           setDefaultCheckType(Id);
           setDefaultChecked(Id);
       }
       else {
           setDefaultCheckType(null);
           setDefaultChecked(null);
       }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Master UTM Format</div>
                    <span className="ms-1">/</span> <span className="text-danger fw-bold">{utmTitle}</span>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ UTM {utmTitle} <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="inputTypex" className="form-label">Input Type</label>
                                <select className="form-select" id="inputType" onChange={(event) => onChangeInputType(event.target.value)} value={inputType ?? ''}>
                                    <option value="0">Default/Dropdown</option>
                                    <option value={Utils.API_TYPE_CONTENT_ID}>Master File : Content ID</option>
                                    <option value={Utils.API_TYPE_OWNER_ID}>Master File : Owner ID</option>
                                    <option value={Utils.API_TYPE_PROJECT_SLUG}>AUTO : Project Slug</option>
                                    <option value={Utils.API_TYPE_CAMPAIGN_ID}>AUTO : Campaign ID</option>
                                    <option value={Utils.API_TYPE_PROMOTION_SLUG}>AUTO : Promotion Slug</option>
                                    <option value={Utils.API_TYPE_PROJECT_ID}>AUTO : Project ID</option>
                                    <option value={Utils.API_TYPE_PROJECT_NAME}>AUTO : Project Name</option>
                                    <option value={Utils.API_TYPE_CAMPAIGN_NAME}>AUTO : Campaign Name</option>
                                    <option value={Utils.API_TYPE_LINE_OAID}>AUTO : Project LINE OAID</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <label htmlFor="defaultCheckTypex" className="form-label">Default Check Type</label>
                                <select className="form-select" id="defaultCheckType" onChange={(event) => onChangeDefaultCheckType(event.target.value)} value={selectedDefaultChecked ?? ''}>
                                    <option value="0">None</option>
                                    <option value={Utils.UTM_SOURCE_DEFAULT_CHECKED}>Checked : can be uncheck</option>
                                    <option value={Utils.UTM_SOURCE_DEFAULT_UNCHECKED}>Checked : do not unchecked</option>
                                </select>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <label htmlFor="encryptChecked" className="form-label">Encrypt</label>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" name="encryptChecked" id="status" checked={encryptChecked} onChange={e => {setEncryptChecked(e.target.checked)}} />
                                            <label className="form-check-label" htmlFor="encryptChecked"></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-9">
                                        <label htmlFor="prefix" className="form-label">Prefix <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" id="prefix" ref={refPrefix} maxLength={1} disabled={!encryptChecked} />
                                        <p className="my-1 text-danger small">เป็นตัวอักษรพิมพ์ใหญ่ A-Z จำนวน 1 ตัวอักษร เช่น A</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to={backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 